import React, { useRef, useState, useEffect } from "react";
import { useAuth, useMenu, useUI } from "../hooks/state";

const HeroVideo = () => {
  const videoRef = useRef(null);
  const hasPlayedRef = useRef(false);
  const [showText, setShowText] = useState(true);
  const { setIsRegistering } = useAuth();
  const { toggleMenu } = useMenu();
  const { isMobile } = useUI();

  // Autoplay after delay
  useEffect(() => {
    const timer = setTimeout(() => {
      if (videoRef.current && !hasPlayedRef.current) {
        videoRef.current.play().catch(() => {});
        setShowText(false);
      }
    }, 12000); // 12 sec
    return () => clearTimeout(timer);
  }, []);

  const handlePlayClick = () => {
    if (videoRef.current) {
      hasPlayedRef.current = true;
      videoRef.current.play().catch(() => {});
      setShowText(false);
    }
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: isMobile ? "480px" : "960px",
        margin: "0 auto",
        aspectRatio: isMobile ? "9 / 16" : "16 / 9",
      }}
    >
      <video
        ref={videoRef}
        muted
        controls
        playsInline
        preload="metadata"
        style={{ width: "100%", borderRadius: "12px" }}
        onEnded={() => {
          if (videoRef.current) {
            videoRef.current.currentTime = 0;
            videoRef.current.pause();
          }
          setShowText(true);
        }}
      >
        <source
          src={
            isMobile
              ? `${process.env.PUBLIC_URL}/media/PriorityPop_Hero_Mobile.mp4`
              : `${process.env.PUBLIC_URL}/media/PriorityPop_Hero.mp4`
          }
          type="video/mp4"
        />
        Your browser does not support video playback.
      </video>

      {showText && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            borderStyle: "solid",
            borderWidth: "2px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: isMobile ? "center" : "space-between",
            textAlign: isMobile ? "center" : "left",
            padding: "30px",
            color: "white",
            zIndex: 2,
            transition: "opacity 1s ease",
          }}
        >
          {/* Left side stacked text and sign up button*/}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              maxWidth: "480px",
              marginLeft: "10%",
            }}
          >
            <h2>
              Forget lists.<br></br>Prioritize visually with PriorityPop.
            </h2>
            {!isMobile && (
              <button
                style={{
                  marginTop: "0px",
                  padding: "12px 12px",
                  background: "#7f63f1",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setIsRegistering(true);
                  toggleMenu();
                }}
              >
                SIGN UP
              </button>
            )}
          </div>

          {/* Right side play button*/}
          {!isMobile && (
            <>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  onClick={handlePlayClick}
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    borderWidth: "4px",
                    borderStyle: "dashed",
                    borderColor: "#30198d",
                    background: "#7f63f1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "white",
                    marginRight: "5%",
                  }}
                >
                  ▶
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default HeroVideo;
